import noodleApiClient from '@/tsClient/servers/noodleApi';

/** Provenance metadata describing the origin of a case data field value. */
type CaseDataProvenance = {
  actorId: string | null;
  createdAt: string;
  sourceCategory: string;
  sourceId: string | null;
};

/** A single version entry in a case data field's history. */
type CaseDataFieldVersion = {
  id: string;
  provenance: CaseDataProvenance;
  value: unknown;
};

/** A resolved case data field with its current value, conflict status, and history. */
type ResolvedCaseDataField = {
  fieldPath: string;
  history: CaseDataFieldVersion[];
  isConflicted: boolean;
  provenance: CaseDataProvenance;
  value: unknown;
};

/** Response from the case data API for a given case. */
type CaseDataResponse = {
  caseId: string;
  fields: Record<string, ResolvedCaseDataField | null>;
  hasConflicts: boolean;
};

type Input = {
  caseId: string;
};

/** Fetches resolved case data fields for a given case. */
const getCaseData = async ({ caseId }: Input): Promise<CaseDataResponse> => {
  const response = await noodleApiClient.get(`/cases/${caseId}`);
  return response.data as CaseDataResponse;
};

export type { CaseDataFieldVersion, CaseDataProvenance, ResolvedCaseDataField, CaseDataResponse };
export default getCaseData;
